import { FileSyncOutlined } from "@ant-design/icons";
import { bomUpdateAuthScope, CrudOp } from "@org-avp/avp-avengers-ui-shared-auth";
import { Translations, ViewIsAuthorized, ViewModule } from "@org-avp/avp-avengers-ui-shared-utils";
import de from "../../public/locales/de.json";
import en from "../../public/locales/en.json";
import { UpdateMonitorView } from "./lazy-view";

const translations: Translations = { de, en };
const isAuthorized: ViewIsAuthorized = (authHelperCreator, { project }) => {
  const authHelper = authHelperCreator(bomUpdateAuthScope);
  return project != null && authHelper.evaluate(CrudOp.READ, project);
};

export const updateMonitorViewKey = "project_modular_update-monitor/:brand/:bomDataSource/:projectId/:subprojectId";
export const updateMonitorViewModule: ViewModule = {
  viewKey: updateMonitorViewKey,
  viewEl: <UpdateMonitorView/>,
  displayNameI18nKey: "updateMonitor:viewName",
  menuIconEl: <FileSyncOutlined/>,
  isAuthorized,
  translations,
};
